import React from "react";
import { Row, Col, Container } from "react-bootstrap";

const Step9 = ({ text, formToShow, deliveryInfo }) => {
  // Helper function to render a section if its step is activated
  const renderSection = (title, content, stepIndex) => {
    // If stepIndex is provided and formToShow exists, check if that step is activated
    if (stepIndex !== undefined && formToShow) {
      const stepItem = formToShow.find((item) => item.Index === stepIndex);

      // Skip this section if the step is not activated
      if (!stepItem || !stepItem.IsActivated) {
        return null;
      }
    }
    //console.log("Text: ", text);
    // Always render the section if the step is activated, even if content is empty
    return (
      <section className="step9-section">
        <header className="step9-section-title">{title}</header>
        <div className="step9-section-body">{content}</div>
      </section>
    );
  };

  const formatSendMaterialValue = (value) => {
    if (value === "YES") {
      return "Ja";
    }
    if (value === "NO") {
      return "Nej";
    }
    return "-";
  };

  const formatAddressLines = (value) => {
    if (!value) {
      return [];
    }

    return value
      .split(",")
      .map((part) => part.trim())
      .filter((part) => part.length >= 3);
  };

  const hasProductCatalogueItems =
    Array.isArray(text.productCatalogueItems) &&
    text.productCatalogueItems.length > 0;

  const productLabel =
    hasProductCatalogueItems && text.productCatalogueItems.length > 1
      ? "Beställda produkter:"
      : "Beställd produkt:";

  const productDisplay = hasProductCatalogueItems
    ? text.productCatalogueItems
        .map((item) => `${item.groupCode}-${item.code} (${item.amount || 0})`)
        .join(", ")
    : text.product || "-";

  // Step 1 is always shown
  const generalInfoSection = (
    <>
      <Row>
        <Col md={4}>Kort beskrivning:</Col>
        <Col md={8}>{text.shortDesc || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ref nr:</Col>
        <Col md={8}>{text.referensnummer || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Beställare:</Col>
        <Col md={8}>{text.clientContact || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Önskad starttid:</Col>
        <Col md={8}>
          {text.requiredStartDate
            ? text.requiredStartDate.replace("T", " ")
            : "-"}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Önskad sluttid:</Col>
        <Col md={8}>
          {text.requiredEndDate ? text.requiredEndDate.replace("T", " ") : "-"}
        </Col>
      </Row>
      <Row>
        <Col md={4}>{productLabel}</Col>
        <Col md={8}>{productDisplay}</Col>
      </Row>
    </>
  );

  // Step 2 - Customer information
  const customerInfoSection = (
    <>
      <Row>
        <Col md={4}>Namn:</Col>
        <Col md={8}>{text.customerName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.customerPhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.customerAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.customerPostalcode || "-"} {text.customerCity || ""}
        </Col>
      </Row>
    </>
  );

  // Step 3 - Customer key information
  const customerKeySection = (
    <>
      <Row>
        <Col md={4}>Nyckel ID:</Col>
        <Col md={8}>{text.customerKeyID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.customerKeyAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Kontaktperson:</Col>
        <Col md={8}>{text.customerKeyName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.customerKeyPhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ring för åtkomst/nyckel:</Col>
        <Col md={8}>{text.customerCallForAccess || "-"}</Col>
      </Row>
    </>
  );

  // Step 4 - Site details
  const siteDetailsSection = (
    <>
      <Row>
        <Col md={4}>Site ID:</Col>
        <Col md={8}>{text.siteID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.siteAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.sitePostalcode || "-"} {text.siteCity || ""}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Våning:</Col>
        <Col md={8}>{text.siteFloor || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Rad/Stativ:</Col>
        <Col md={8}>{text.siteRow || "-"}</Col>
      </Row>
    </>
  );

  // Step 5 - Site access
  const siteAccessSection = (
    <>
      <Row>
        <Col md={4}>Nyckel ID:</Col>
        <Col md={8}>{text.accessSiteKeyID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Adress:</Col>
        <Col md={8}>{text.accessSiteAddress || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Postnummer och ort:</Col>
        <Col md={8}>
          {text.accessSitePostalcode || "-"} {text.accessSiteCity || ""}
        </Col>
      </Row>
      <Row>
        <Col md={4}>Namn:</Col>
        <Col md={8}>{text.accessSiteName || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Telefon:</Col>
        <Col md={8}>{text.accessSitePhone || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Ring för åtkomst/nyckel:</Col>
        <Col md={8}>{text.accessSiteCallForAccess || "-"}</Col>
      </Row>
    </>
  );

  // Step 6 - Equipment / Connection
  const equipmentSection = (
    <>
      <Row>
        <Col md={4}>Utrustnings ID:</Col>
        <Col md={8}>{text.equipmentID || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Interface:</Col>
        <Col md={8}>{text.equipmentInterface || "-"}</Col>
      </Row>
      <Row>
        <Col md={4}>Förbindelsenummer:</Col>
        <Col md={8}>{text.equipmentConnectionNumber || "-"}</Col>
      </Row>
    </>
  );

  const sendMaterialDisplay = formatSendMaterialValue(text.sendMaterial);
  const showDeliveryInfo = text.sendMaterial === "YES";

  const addressRows = [
    {
      label: "Leveransadress",
      value: formatAddressLines(deliveryInfo?.LeveransAdress),
    },
    {
      label: "Leveransmottagare",
      value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    },
    // {
    //   label: "Alternativ leveransmottagare",
    //   value: formatAddressLines(deliveryInfo?.Alternativkontaktperson),
    // },
  ];

  const filteredAddressRows = addressRows.filter((row) => row.value.length > 0);

  const deliveryTermsRows = [
    {
      label: "Bemanning dagtid",
      value: deliveryInfo?.Bemanning_dagtid,
    },
    {
      label: "Tar emot EU pall",
      value: deliveryInfo?.Tar_emot_pallar,
    },
    {
      label: "Förvaring inomhus",
      value: deliveryInfo?.["Förvaring_inomhus"],
    },
  ];

  const filteredDeliveryTermsRows = deliveryTermsRows.filter(
    (row) => row.value !== "-",
  );
  const hasDeliveryDetails =
    filteredAddressRows.length > 0 || filteredDeliveryTermsRows.length > 0;

  // Step 7 - Material details
  const materialSection = (
    <>
      <Row>
        <Col md={4}>Skicka material:</Col>
        <Col md={8}>{sendMaterialDisplay}</Col>
      </Row>
      {showDeliveryInfo && (
        <Row>
          <Col md={12}>
            {deliveryInfo && hasDeliveryDetails ? (
              <div className="step9-delivery-columns">
                {filteredAddressRows.length > 0 && (
                  <div className="step9-delivery-column">
                    {filteredAddressRows.map(({ label, value }) => (
                      <div key={label} className="step9-delivery-field">
                        <span className="step9-delivery-label">{label}</span>
                        {value.map((line, index) => (
                          <span
                            key={`${label}-${index}`}
                            className="step9-delivery-value-line"
                          >
                            {line}
                          </span>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
                {filteredDeliveryTermsRows.length > 0 && (
                  <div className="step9-delivery-column step9-delivery-boolean">
                    {filteredDeliveryTermsRows.map(({ label, value }) => (
                      <div key={label} className="step9-delivery-field">
                        <span className="step9-delivery-label">{label}</span>
                        <span className="step9-delivery-value-line">
                          {value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <div className="step9-delivery-fallback">
                Ingen leveransinformation hittades.
              </div>
            )}
          </Col>
        </Row>
      )}
      <Row>
        <Col md={4}>Info returhantering:</Col>
        <Col md={8}>{text.infoMtrlReturnMtrl || "-"}</Col>
      </Row>
    </>
  );

  // Step 8 - Work description
  const workDescriptionSection = (
    <Row>
      <Col md={12}>
        {text.longWorkDesc || "Ingen arbetsbeskrivning angiven"}
      </Col>
    </Row>
  );

  return (
    <Container className="summaryContainer">
      <h4>Sammanfattning av din beställning</h4>

      {/* Step 1 - General info is always shown */}
      {renderSection("Grundläggande information", generalInfoSection, 1)}

      {/* Step 2 - Customer information */}
      {renderSection(
        "Kontaktinformation för felavhjälpning eller installation",
        customerInfoSection,
        2,
      )}

      {/* Step 3 - Customer key info */}
      {renderSection("Åtkomst slutkund/företag", customerKeySection, 3)}

      {/* Step 4 - Site details */}
      {renderSection("Site detaljer", siteDetailsSection, 4)}

      {/* Step 5 - Site access */}
      {renderSection("Tillträde site", siteAccessSection, 5)}

      {/* Step 6 - Equipment / Connection */}
      {renderSection("Utrustning / Avlämningspunkt", equipmentSection, 6)}

      {/* Step 7 - Material details */}
      {renderSection("Material & reservdelar", materialSection, 7)}

      {/* Step 8 - Work description is always shown */}
      {renderSection("Arbetsbeskrivning", workDescriptionSection, 8)}
    </Container>
  );
};

export default Step9;
